export default "__VITE_ASSET__cLJ1K4Fm__"